// src/features/roadmap/RoadmapPage.jsx
//
// ROADMAP-PROMOTE: Full-width Roadmap landing page.
// Promoted from the Admin sub-nav "Build Status" section to a top-level
// left-nav destination (admin-only). Wraps FeatureInventoryPanel with
// a StandardPageHeader and the canonical PAGE_ZONE container.
//
// ROADMAP-WORKFLOW-VIEW-S1: Added segmented toggle (Build status / Workflow)
// and a per-object WorkflowView driven by workflowDefinitions.js.

import React, { useState } from "react";
import { PAGE_ZONE } from "../../app/styles.js";
import { T } from "../../app/tokens.js";
import { FeatureInventoryPanel } from "../admin/FeatureInventoryPanel.jsx";
import { WorkflowView } from "./WorkflowView.jsx";
import { WORKFLOW_DEFINITIONS, WORKFLOW_OBJECT_SLUGS } from "./workflowDefinitions.js";
import { ToolbarViewToggle } from "../../v2/components/ToolbarViewToggle.jsx";

const ROADMAP_SEGMENTS = [
  { key: "build",    label: "Build status" },
  { key: "workflow", label: "Workflow"      },
];

// ─── Object selector ──────────────────────────────────────────────────────────

function ObjectSelector({ value, onChange }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      data-testid="workflow-object-select"
      style={{
        fontSize:     T.fsSm,
        fontWeight:   T.fwSemibold,
        color:        T.dark,
        background:   T.white,
        border:       `1px solid ${T.border}`,
        borderRadius: 6,
        padding:      "5px 12px",
        cursor:       "pointer",
        fontFamily:   "inherit",
      }}
    >
      {WORKFLOW_OBJECT_SLUGS.map(({ slug, label }) => (
        <option key={slug} value={slug}>
          {label}
          {!WORKFLOW_DEFINITIONS[slug] ? "- not yet mapped" : ""}
        </option>
      ))}
    </select>
  );
}

// ─── Page ─────────────────────────────────────────────────────────────────────

export function RoadmapPage() {
  const [activeView,     setActiveView]     = useState("build");
  const [selectedObject, setSelectedObject] = useState(WORKFLOW_OBJECT_SLUGS[0].slug);

  const selectedLabel = WORKFLOW_OBJECT_SLUGS.find((o) => o.slug === selectedObject)?.label ?? selectedObject;
  const definition    = WORKFLOW_DEFINITIONS[selectedObject] ?? null;

  return (
    <div style={{ ...PAGE_ZONE, padding: "28px 0 40px" }}>
      {/* Controls row */}
      <div
        style={{
          display:    "flex",
          alignItems: "center",
          gap:        12,
          marginBottom: 24,
        }}
      >
        <ToolbarViewToggle
          testId="roadmap-view-toggle"
          segments={ROADMAP_SEGMENTS}
          value={activeView}
          onChange={setActiveView}
        />
        {activeView === "workflow" && (
          <ObjectSelector value={selectedObject} onChange={setSelectedObject} />
        )}
      </div>

      {/* View */}
      {activeView === "build" ? (
        <FeatureInventoryPanel />
      ) : (
        <WorkflowView definition={definition} objectLabel={selectedLabel} />
      )}
    </div>
  );
}
